import axios from 'axios'

const {getBaseApiURL} = require('./helpers/baseurl')

export const baseV1URL = getBaseApiURL()

export default {
    common: axios.create({
        baseURL: getBaseApiURL()
    }),
    v1: axios.create({
        baseURL: getBaseApiURL('v1')
    }),
    v2: axios.create({
        baseURL: getBaseApiURL('v2')
    })
}